import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from 'react-intl';

import Notification from '../notification/Notification';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import CheckoutWalletForm from './CheckoutWalletForm';

export default function CheckoutWallet({available, max, selected, couponActived, onChange}) {
  return (
    <div className="checkout__wallet">
      {selected ? (
        <Notification onClose={() => onChange(0)}>
          <FormattedMessage
            id="page.checkout.wallet.used"
            values={{amount: <ChannelPrice component="b" price={selected}/>}}
          />
        </Notification>
      ) : (
        <CheckoutWalletForm
          available={available}
          max={max}
          initialValues={{ funds: undefined }}
          couponActived={couponActived}
          onSubmit={({funds}) => onChange(funds)}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutWallet.js